import { useNavigate } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { ampli } from '../../../../ampli';
import { BottomFloatingButton } from '../../../../components/common/buttons/FloatingButtons/BottomFloatingButton';

interface SellTractorButtonProps {
  pageType: 'plp' | 'olp' | 'myinfo';
}

// TODO: components로 파일 위치 변경.
export const SellTractorButton = ({ pageType }: SellTractorButtonProps) => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    ampli.pvmClickSellTractorButton({
      page_type: pageType,
    });
    ReactGA.event('pvm_click_sell_tractor_button', {
      category: pageType,
      action: 'pvm_click_sell_tractor_button',
    });
    navigate('/survey/entry/sell-tractor');
  };

  return <BottomFloatingButton handleButtonClick={handleButtonClick} title={'내 트랙터 판매'} />;
};
